import { render, staticRenderFns } from "./SendLeads.vue?vue&type=template&id=c64b415a&"
import script from "./SendLeads.vue?vue&type=script&lang=js&"
export * from "./SendLeads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports